<template>
  <v-card>
    <mf-loading loader="produtos-top" loader-type="table">
      <v-card-title class="d-flex flex-row justify-space-between">
        <span class="table-card-title">Produtos mais comprados</span>
        <export-data :data-fetcher="getDataToExport" filename="produtos_mais_comprados" ghost />
      </v-card-title>
      <v-data-table :items="items" :headers="headers">
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <a class="link" @click="redirectProduto(item['COD_ID_PRODUTO'])">{{ item['COD_ID_PRODUTO'] }}</a>
            </td>
            <td>{{ item['DES_PRODUTO'] }}</td>
            <td class="text-right">{{ item['VAL_FATURAMENTO_TOTAL'] | localeString(2) | currency }}</td>
          </tr>
        </template>
      </v-data-table>
    </mf-loading>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import ExportData from '@/components/export-data/ExportData.vue'
import { localeString } from '@/config/helpers.js'

export default {
  name: 'ProdutoMaisComprado',
  components: {
    ExportData,
  },
  computed: {
    ...mapGetters(['produtosTopMaisFaturados']),
    headers() {
      return [
        {
          text: 'Código do produto',
          value: 'COD_ID_PRODUTO',
          width: '20%',
        },
        {
          text: 'Nome do produto',
          value: 'DES_PRODUTO',
          width: '60%',
        },
        {
          text: 'Gasto por produto',
          align: 'right',
          value: 'VAL_FATURAMENTO_TOTAL',
          width: '20%',
        },
      ]
    },
    items() {
      return this.produtosTopMaisFaturados
    },
  },
  methods: {
    localeString,
    redirectProduto(param) {
      this.$router.push({ path: `/produtos/detalhes-produto/${param}` }).catch(() => {})
    },
    getDataToExport() {
      const headers = this.headers.map((header) => header.text)
      const rows = this.items.map((item) =>
        this.headers.map((header) => {
          return header.value === 'VAL_FATURAMENTO_TOTAL' ? this.localeString(item[header.value]) : item[header.value]
        })
      )
      return { headers, rows }
    },
  },
}
</script>

<style lang="css"></style>
